import { Modal } from "antd";
import { CheckDoubleIcon } from "@/components/icons";
import { useModalStore } from "@/hooks/useModalStore";
import { useTranslation } from "react-i18next";

export default function PublishedVideoModal() {
  const { showPublishedVideoModal, setShowPublishedVideoModal } = useModalStore();
  const { t } = useTranslation();
  
  return (
    <Modal
      open={showPublishedVideoModal}
      title={t('campaignCreate.help.whatHappensAfterPublish')}
      footer={false}
      width={802}
      onCancel={() => setShowPublishedVideoModal(false)}
    >
      {/* <div className="self-stretch inline-flex justify-start items-start gap-5 mt-[40px]">
        <div className="flex-1 inline-flex flex-col justify-center items-start gap-3">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.5049 22.5432C4.0479 22.5432 3.60408 22.3632 3.26809 22.0272C2.79408 21.5542 2.63108 20.8672 2.84108 20.2352L3.6819 17.7342C3.7799 17.4272 3.77102 17.1192 3.65602 16.8762C3.06402 15.6032 2.75392 14.1932 2.75392 12.7932C2.75392 7.41821 7.12697 3.04419 12.502 3.04419C17.878 3.04419 22.251 7.41721 22.251 12.7932C22.251 18.1692 17.878 22.5422 12.502 22.5422C11.103 22.5422 9.69302 22.2312 8.42702 21.6422C8.17902 21.5232 7.86902 21.5152 7.55202 21.6162L5.06301 22.4522C4.87801 22.5132 4.6899 22.5432 4.5049 22.5432ZM12.501 4.54419C7.953 4.54419 4.25295 8.24421 4.25295 12.7932C4.25295 13.9762 4.51596 15.1672 5.01296 16.2372C5.28896 16.8182 5.32493 17.5172 5.10793 18.2002L4.26393 20.7112C4.22193 20.8362 4.2859 20.9252 4.3279 20.9672C4.3699 21.0092 4.45998 21.0732 4.58498 21.0312L7.08303 20.1922C7.77703 19.9712 8.47696 20.0052 9.06496 20.2862C10.127 20.7802 11.318 21.0432 12.501 21.0432C17.05 21.0432 20.75 17.3432 20.75 12.7942C20.75 8.24519 17.05 4.54419 12.501 4.54419ZM12.5 17.5442C12.395 17.5442 12.2889 17.5222 12.1909 17.4782C12.0379 17.4092 8.42691 15.7462 7.83791 12.7322C7.59991 11.5132 7.83608 10.3572 8.48708 9.56219C9.02908 8.90119 9.80309 8.54919 10.7261 8.54419C10.7311 8.54419 10.736 8.54419 10.74 8.54419C11.51 8.54419 12.089 8.86119 12.499 9.26019C12.912 8.85819 13.463 8.54019 14.27 8.54419C15.194 8.54819 15.968 8.90022 16.51 9.56122C17.16 10.3552 17.398 11.5102 17.159 12.7312C16.57 15.7462 12.9599 17.4082 12.8059 17.4772C12.7109 17.5222 12.605 17.5442 12.5 17.5442ZM10.74 10.0442C10.738 10.0442 10.7371 10.0442 10.7351 10.0442C10.2661 10.0462 9.90097 10.2042 9.64797 10.5122C9.28697 10.9532 9.16105 11.6752 9.31105 12.4432C9.66605 14.2622 11.711 15.5262 12.499 15.9532C13.287 15.5272 15.332 14.2622 15.687 12.4442C15.837 11.6752 15.7111 10.9522 15.3501 10.5122C15.0971 10.2042 14.732 10.0472 14.262 10.0442C14.261 10.0442 14.2591 10.0442 14.2571 10.0442C13.5211 10.0442 13.2361 10.7742 13.2071 10.8582C13.1 11.1562 12.815 11.3582 12.499 11.3582C12.497 11.3582 12.494 11.3582 12.491 11.3582C12.172 11.3552 11.8881 11.1532 11.7871 10.8502C11.7621 10.7742 11.478 10.0442 10.74 10.0442ZM16.4251 12.5872H16.4351H16.4251Z"
              fill="#25314C"
            />
          </svg>

          <div className="self-stretch inline-flex justify-start items-start gap-1">
            <div className="flex-1 justify-start text-color-text-primary text-sm font-medium  leading-tight">
              Sends invites to influencers
            </div>
          </div>
        </div>
        <div className="w-0 h-11 outline outline-1 outline-offset-[-0.50px] outline-zinc-100" />
        <div className="flex-1 inline-flex flex-col justify-center items-start gap-3">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 4.04419H6C3.582 4.04419 2.25 5.45815 2.25 8.02515V15.5632C2.25 18.1302 3.582 19.5442 6 19.5442H18C20.418 19.5442 21.75 18.1302 21.75 15.5632V8.02515C21.75 5.45815 20.418 4.04419 18 4.04419ZM20.25 15.5632C20.25 17.3022 19.577 18.0442 18 18.0442H6C4.423 18.0442 3.75 17.3022 3.75 15.5632V8.02515C3.75 6.28615 4.423 5.54419 6 5.54419H18C19.577 5.54419 20.25 6.28615 20.25 8.02515V15.5632ZM17.75 21.7942C17.75 22.2082 17.414 22.5442 17 22.5442H7C6.586 22.5442 6.25 22.2082 6.25 21.7942C6.25 21.3802 6.586 21.0442 7 21.0442H17C17.414 21.0442 17.75 21.3802 17.75 21.7942ZM14.9729 10.4092L11.825 8.48218C11.303 8.16218 10.647 8.15022 10.114 8.44922C9.57301 8.75222 9.25098 9.30214 9.25098 9.92114V13.6672C9.25098 14.2862 9.57301 14.8362 10.114 15.1392C10.371 15.2832 10.6559 15.3552 10.9409 15.3552C11.2479 15.3552 11.554 15.2722 11.825 15.1062L14.9719 13.1802C15.4589 12.8822 15.75 12.3642 15.75 11.7942C15.75 11.2242 15.4589 10.7062 14.9729 10.4092ZM14.189 11.9001L11.041 13.8271C10.959 13.8771 10.8909 13.8553 10.8469 13.8313C10.8029 13.8063 10.75 13.7582 10.75 13.6672V9.92114C10.75 9.83114 10.8029 9.78208 10.8469 9.75708C10.8709 9.74308 10.9039 9.7312 10.9419 9.7312C10.9719 9.7312 11.006 9.73923 11.042 9.76123L14.1899 11.6882C14.1899 11.6882 14.1899 11.6882 14.1909 11.6882C14.2299 11.7122 14.251 11.7482 14.251 11.7932C14.251 11.8382 14.229 11.8761 14.189 11.9001Z"
              fill="#25314C"
            />
          </svg>
          <div className="self-stretch inline-flex justify-start items-start gap-1">
            <div className="flex-1 justify-start text-color-text-primary text-sm font-medium  leading-tight">
              Influencers produce content
            </div>
          </div>
        </div>
        <div className="w-0 h-11 outline outline-1 outline-offset-[-0.50px] outline-zinc-100" />
        <div className="flex-1 inline-flex flex-col justify-center items-start gap-3">
          <CheckDoubleIcon className="w-[24px] h-[24px]" />
          <div className="flex flex-col justify-start items-start">
            <div className="inline-flex justify-start items-start gap-1">
              <div className="justify-start text-color-text-primary text-sm font-medium  leading-tight">
                You approve content
              </div>
            </div>
          </div>
        </div>
        <div className="w-0 h-11 outline outline-1 outline-offset-[-0.50px] outline-zinc-100" />
        <div className="flex-1 inline-flex flex-col justify-center items-start gap-3">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.7498 7.79419V11.9482C21.7498 12.3622 21.4138 12.6982 20.9998 12.6982C20.5858 12.6982 20.2498 12.3622 20.2498 11.9482V9.60522L14.2368 15.6182C13.5538 16.3012 12.4448 16.3012 11.7618 15.6182L9.17577 13.0322C9.07777 12.9342 8.91978 12.9342 8.82178 13.0322L3.52877 18.3252C3.38277 18.4712 3.19077 18.5452 2.99877 18.5452C2.80677 18.5452 2.61477 18.4722 2.46877 18.3252C2.17577 18.0322 2.17577 17.5572 2.46877 17.2642L7.76177 11.9712C8.44477 11.2882 9.55377 11.2882 10.2368 11.9712L12.8228 14.5571C12.9208 14.6551 13.0788 14.6551 13.1768 14.5571L19.1898 8.54419H16.8468C16.4328 8.54419 16.0968 8.20819 16.0968 7.79419C16.0968 7.38019 16.4328 7.04419 16.8468 7.04419H20.9998C21.0978 7.04419 21.1948 7.06429 21.2868 7.10229C21.4698 7.17829 21.6158 7.3243 21.6918 7.5083C21.7298 7.5993 21.7498 7.69619 21.7498 7.79419Z"
              fill="#25314C"
            />
          </svg>
          <div className="flex flex-col justify-start items-start">
            <div className="inline-flex justify-start items-start gap-1">
              <div className="justify-start text-color-text-primary text-sm font-medium  leading-tight">
                You get results
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="mt-6 w-full rounded-lg overflow-hidden">
        {showPublishedVideoModal && (
          <iframe
            className="w-full h-[412px]"
            width="560"
            height="412"
            src="https://www.youtube.com/embed/xtQzhP69rw4?si=A7FuMmbaq3Wdu_rU"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        )}
      </div>
    </Modal>
  );
}
